export const JWT_LIFETIME = 1440
export const JWT_REFRESH_LIFETIME = 1440